"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/*
  The MIT License

  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
var maxBy_1 = tslib_1.__importDefault(require("lodash/maxBy"));
var react_1 = tslib_1.__importDefault(require("react"));
var UnknownRenderer_1 = require("./UnknownRenderer");
var JsonFormsContext_1 = require("./JsonFormsContext");
/**
 * Dispatch renderer component for cells.
 */
var Dispatch = /** @class */ (function (_super) {
    tslib_1.__extends(Dispatch, _super);
    function Dispatch() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Dispatch.prototype.render = function () {
        var _a = this.props, uischema = _a.uischema, schema = _a.schema, path = _a.path, cells = _a.cells, id = _a.id, enabled = _a.enabled, renderers = _a.renderers;
        var cell = maxBy_1.default(cells, function (r) { return r.tester(uischema, schema); });
        if (cell === undefined || cell.tester(uischema, schema) === -1) {
            return react_1.default.createElement(UnknownRenderer_1.UnknownRenderer, { type: 'cell' });
        }
        else {
            var Cell = cell.cell;
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Cell, { uischema: uischema, schema: schema, enabled: enabled, path: path, id: id, renderers: renderers, cells: cells })));
        }
    };
    return Dispatch;
}(react_1.default.Component));
exports.DispatchCell = JsonFormsContext_1.withJsonFormsDispatchCellProps(Dispatch);
//# sourceMappingURL=DispatchCell.js.map